webpackJsonp([2],{

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(478);


/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Feature detect your browser by adding classes to the document tag.
// So you can adapt your application for older browsers.

/* eslint-disable */
!function () {
  var touch = void 0;
  var ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

  var hasHistoryFeature = function hasHistoryFeature() {
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
      return false;
    }

    return window.history && 'pushState' in window.history;
  };

  var hasWebsockets = function hasWebsockets() {
    return 'WebSocket' in window && window.WebSocket.CLOSING === 2;
  };

  var hasFileApi = function hasFileApi() {
    return !!(window.File && window.FileList && window.FileReader);
  };

  var hasTouchEvents = function hasTouchEvents() {
    return 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;
  };

  var isInternetExplorer = function isInternetExplorer() {
    return (/msie|trident/i.test(ua)
    );
  };

  var classes = [];

  var features = {
    history: hasHistoryFeature(),
    websocket: hasWebsockets(),
    file: hasFileApi(),
    touch: touch = hasTouchEvents(),
    'no-touch': !touch,
    msie: isInternetExplorer()
  };

  for (var feature in features) {
    if (!features[feature]) {
      continue;
    }
    classes.push(feature);
  }

  var _document = document,
      documentElement = _document.documentElement;
  var className = documentElement.className;

  var reJS = new RegExp('(^|\\s)no-js(\\s|$)');
  className = className.replace(reJS, '$1js $2');
  className += classes.join(' ');
  return documentElement.className = className;
}();

/***/ })

},[477]);


// WEBPACK FOOTER //
// javascripts/degradizr-df83d55b2c52b6b0244f.js